import { type I18n } from '@lingui/core';
import { t } from '@lingui/macro';

export const getHardwareOptionTypesTranslationList = (i18n: I18n) => {
  return [
    {
      name: 'battery_capacity',
      translation: t(i18n)`Capacidad de batería`,
    },
    {
      name: 'energization',
      translation: t(i18n)`Energización`,
    },
    {
      name: 'battery_voltage',
      translation: t(i18n)`Voltaje de batería`,
    },
    {
      name: 'power_supply',
      translation: t(i18n)`Fuente de alimentación`,
    },
    {
      name: 'antenna_model',
      translation: t(i18n)`Modelo de antena`,
    },
    {
      name: 'battery_tech',
      translation: t(i18n)`Tecnología de batería`,
    },
    {
      name: 'level_sensor',
      translation: t(i18n)`Sensor de nivel`,
    },
    {
      name: 'mobile_operator',
      translation: t(i18n)`Operador móvil`,
    },
    {
      name: 'flow_sensor',
      translation: t(i18n)`Sensor de flujo`,
    },
    {
      name: 'velocity_sensor',
      translation: t(i18n)`Sensor de velocidad`,
    },
    {
      name: 'angle_sensor',
      translation: t(i18n)`Sensor de ángulo`,
    },
    {
      name: 'internet_connection',
      translation: t(i18n)`Conexión a internet`,
    },
    {
      name: 'data_connection_type',
      translation: t(i18n)`Tipo de conexión de datos`,
    },
    {
      name: 'data_plan_type',
      translation: t(i18n)`Tipo de plan de datos`,
    },
    {
      name: 'cpu',
      translation: t(i18n)`CPU`,
    },
    {
      name: 'satellital_type',
      translation: t(i18n)`Tipo satelital`,
    },
    {
      name: 'sim_model',
      translation: t(i18n)`Modelo de SIM`,
    },
    {
      name: 'image_version',
      translation: t(i18n)`Versión de la imagen`,
    },
    {
      name: 'auxiliary_plate',
      translation: t(i18n)`Placa auxiliar`,
    },
  ];
};

export const getTranslatedHardwareOptionType = (name: string, i18n: I18n) => {
  const translations = getHardwareOptionTypesTranslationList(i18n);
  const translation = translations.find((translation) => translation.name === name);
  return translation?.translation ?? name;
};
